import { IconChevronRight } from "../icon/variants/IconChevronRight.js";
import navlink_module_default from "./navlink.module.js";
import { NavLink } from "@mantine/core";
import { jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";

//#region src/components/nav-link/NavLink.tsx
const NavLink$1 = ({ active, disabled, label, Icon, href, target, onClick, color = "primary", variant = "light", withChevron = true, "data-testid": testId }) => {
	const baseProps = {
		active,
		disabled,
		label,
		leftSection: Icon && /* @__PURE__ */ jsx(Icon, { color }),
		rightSection: withChevron && /* @__PURE__ */ jsx(IconChevronRight, { color }),
		onClick,
		classNames: navlink_module_default,
		variant: variant === "outline" ? "subtle" : variant,
		color,
		"data-testid": testId,
		"data-outline": variant === "outline",
		__vars: { "--nl-text-hover-color": `var(--mantine-color-${color}-9)` },
		role: "link"
	};
	if (href) return /* @__PURE__ */ jsx(NavLink, {
		...baseProps,
		component: Link,
		to: href,
		target
	});
	return /* @__PURE__ */ jsx(NavLink, { ...baseProps });
};

//#endregion
export { NavLink$1 as NavLink };